import React from 'react';
import { MapPin, Phone, Mail, Clock, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gradient-to-r from-gray-900 to-blue-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-200">
              UrbanWall
            </h3>
            <p className="text-gray-300 text-sm">
              Building dreams into reality with excellence and innovation in construction.
            </p>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 group">
                <MapPin className="w-5 h-5 text-blue-400 group-hover:text-blue-300 transition-colors" />
                <p className="text-sm text-gray-300 group-hover:text-white transition-colors">
                  2TF, Block 151, Sector mu 2, Greater Noida, 201310
                </p>
              </div>
              <div className="flex items-center space-x-3 group">
                <Phone className="w-5 h-5 text-blue-400 group-hover:text-blue-300 transition-colors" />
                <p className="text-sm text-gray-300 group-hover:text-white transition-colors">
                  +91 7011523651
                </p>
              </div>
              <div className="flex items-center space-x-3 group">
                <Clock className="w-5 h-5 text-blue-400 group-hover:text-blue-300 transition-colors" />
                <p className="text-sm text-gray-300 group-hover:text-white transition-colors">
                  Mon-Sat: 9:00 AM - 6:00 PM
                </p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Services', 'Projects', 'Contact'].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="text-sm text-gray-300 hover:text-white transition-colors hover:underline"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Connect With Us</h4>
            <div className="flex space-x-4">
              {[
                { Icon: Facebook, label: 'Facebook' },
                { Icon: Twitter, label: 'Twitter' },
                { Icon: Linkedin, label: 'LinkedIn' },
                { Icon: Instagram, label: 'Instagram' }
              ].map(({ Icon, label }) => (
                <a
                  key={label}
                  href={`#${label.toLowerCase()}`}
                  className="bg-blue-800 p-2 rounded-full hover:bg-blue-700 transition-colors"
                  aria-label={label}
                >
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <p className="text-center text-sm text-gray-400">
            © {currentYear} UrbanWall Construction. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;